import { NetworkConfiguration } from "../../network/networkConfriguation";
import { callAPI } from "../../network/networkConnection";

export const submitCantonFairLead = (payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      `${process.env.REACT_APP_APIUrl}${NetworkConfiguration.CANTON_FAIR_LEAD_SUBMIT}`,
      "POST",
      { "Content-Type": "application/json" },
      JSON.stringify(payload)
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};
